import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "services",
  class: "container mx-auto py-24 sm:py-32"
}
const _hoisted_2 = { class: "grid sm:grid-cols-1 lg:grid-cols-3 gap-4 w-full mx-auto" }

import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/landingPage/ui/card";

import { Badge } from "@/components/landingPage/ui/badge";

enum ProService {
  YES = 1,
  NO = 0,
}

interface ServiceProps {
  title: string;
  pro: ProService;
  description: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Services',
  setup(__props) {

const serviceList: ServiceProps[] = [
  {
    title: "👩‍🎓 Parcours Jeune Accompagné",
    description:
      "Tableau de bord personnalisé, mini-jeux ludiques, création d'avatar, recherche de stages et apprentissages avec recommandations IA.",
    pro: 0,
  },
  {
    title: "👨‍🏫 Parcours Accompagnateur",
    description:
      "Suivi des jeunes, analyse de données IA, messagerie sécurisée, création d'ateliers interactifs et gestion des séances d'accompagnement.",
    pro: 0,
  },
  {
    title: "🏢 Portail Entreprise",
    description:
      "Publication d'offres inclusives, découverte de profils talents, formation à la neurodiversité et suivi d'intégration post-recrutement.",
    pro: 1,
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-lg text-[#ff9500] text-center mb-2 tracking-wider" }, " Parcours Utilisateurs ", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-3xl md:text-4xl text-center font-bold mb-4" }, " Trois parcours pour un écosystème inclusif ", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "md:w-1/2 mx-auto text-xl text-center text-muted-foreground mb-8" }, " La plateforme s'adresse aux jeunes neurodivergents, aux accompagnateurs (parents, enseignants, éducateurs) et aux entreprises inclusives. ", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(serviceList, ({ title, description, pro }) => {
        return _createElementVNode("div", { key: title }, [
          _createVNode(_unref(Card), { class: "bg-muted/60 dark:bg-card h-full relative" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(title), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(CardDescription), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(description), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              (pro === ProService.YES)
                ? (_openBlock(), _createBlock(_unref(Badge), {
                    key: 0,
                    variant: "secondary",
                    class: "absolute -top-2 -right-3"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode("Inclusif")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ])
      }), 64))
    ])
  ]))
}
}

})